module.exports = __webpack_public_path__ + "img/alert-error.f42aab50.svg";